const ADDRESS_FIELDS_TO_BE_MERGED_COUNT = 3;

const addressOptions = [
  'flatNumber', // it is kept because of backwards compatibility
  'houseNameOrNumber', // it is kept because of backwards compatibility
  'street1',
  'street2',
  'street3',
  'street4',
  'city',
  'county',
  'postcode',
];
const separator = ' [&] ';

const sortAddressAnswers = (answers) =>
  Object.entries(answers)
    .sort((a, b) => addressOptions.indexOf(a[0]) - addressOptions.indexOf(b[0]))
    .map(([, value]) => value);

export const formatAddressAnswerToString = (answers) => [
  sortAddressAnswers(answers)
    .map((addressField) => addressField.trim())
    .filter((addressFiled) => addressFiled)
    .join(', ')
    .trim(),
];

export const formatFormattedAddressAnswerToString = (answers) => [
  sortAddressAnswers(answers).join(separator),
];

const buildStreet1Address = (answers) =>
  answers.slice(0, ADDRESS_FIELDS_TO_BE_MERGED_COUNT).filter(Boolean).join(', ');

const isDeprecatedAddressFormat = (answers) => answers.length === addressOptions.length;

export const restoreAddressAnswer = ([answer]) => {
  if (answer.includes(separator)) {
    const answers = answer.split(separator);

    if (isDeprecatedAddressFormat(answers)) {
      const splicedAnswers = answers.slice(ADDRESS_FIELDS_TO_BE_MERGED_COUNT, answers.length);

      return splicedAnswers.reduce(
        (acc, curr, idx) => ({
          ...acc,
          [addressOptions[idx + ADDRESS_FIELDS_TO_BE_MERGED_COUNT]]: curr,
        }),
        {
          street1: buildStreet1Address(answers),
        },
      );
    }

    return answer.split(separator).reduce(
      (acc, curr, idx) => ({
        ...acc,
        [addressOptions[idx + ADDRESS_FIELDS_TO_BE_MERGED_COUNT - 1]]: curr,
      }),
      {},
    );
  }
  return answer;
};

// might be needed for manage appointments
export const restoreAddressAnswerToString = (answers) =>
  answers &&
  answers.length &&
  Object.values(restoreAddressAnswer(answers))
    .filter((value) => value.length !== 0)
    .join(', ');
